import { render } from "./PanguinPage.vue?vue&type=template&id=7ef5f220&scoped=true"
import script from "./PanguinPage.vue?vue&type=script&lang=js"
export * from "./PanguinPage.vue?vue&type=script&lang=js"

import "./PanguinPage.vue?vue&type=style&index=0&id=7ef5f220&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef5f220"]])

export default __exports__